/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { AccessType } from "@quintype/components";
import { TextField } from "../../atoms/textfield";
import { updateFirebaseUser, checkForMemberInFirebase, getPodcastToken } from "../../helper/api";
import { ACCOUNT_DETAILS_URL } from "../../../constants";
import { LoginButton } from "../../molecules/login-button";
import Loader from "../../atoms/loader";
import { IS_SUBSCRIPTION_CANCEL, SELECTED_PLAN, PAYMENT_CHECKOUT_PAGE } from "../../helper/actions";
import IntegrationData from "../../../../../config/integrations.js";
import "./account-details.m.css";
import { MdContentCopy } from "react-icons/md";
import { useUserSubscription, useCopyToClipboard } from "../../helper/hooks";
import { isEmpty } from "lodash";
import { AiFillAndroid } from "react-icons/ai";
const shows = require("./shows.json");

const GetCards = ({
  subscriptions = [],
  config,
  navigateTo,
  cancelSubscription,
  subscriptionManage,
  isSubscriptionCanceled,
  selectedPlan,
  groupSubscription,
  campaignSubscriptions,
  hostUrl
}) => {
  const [sucMessage, setsucMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [cancelSubscriptionState, setCancelSubcription] = useState({});
  const CancelSubscriptionPlan = subscription => {
    var response = confirm(
      "Are you sure you want to stop supporting us? We depend entirely on support from our readers. Your subscription directly powers our ground reportage and podcasts."
    );
    if (response === true) {
      setLoading(true);
      setCancelSubcription(subscription);
      cancelSubscription(subscription.id)
        .then(() => {
          setLoading(false);
          subscriptionManage({ status: true });
          setsucMessage("Your subscription has been cancelled");
          setTimeout(() => {
            setsucMessage(" ");
          }, 3000);
        })
        .catch(error => {
          setLoading(false);
          subscriptionManage({ status: false });
          setErrorMessage(error.message);
          setTimeout(() => {
            setErrorMessage(" ");
          }, 3000);
        });
    }
  };

  const paymentCheckout = subscription => {
    if (subscription.subscription_type === "campaign") {
      const renewSubscriptions =
        campaignSubscriptions.map(plans =>
          plans.subscription_plans.filter(plan => plan.id === subscription.subscription_plan_id)
        ) || [];
      const renewSubscription = renewSubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];
      selectedPlan(renewSubscription[0][0], ACCOUNT_DETAILS_URL);
      navigateTo(`/payment-checkout`);
    } else {
      const renewSubscriptions =
        groupSubscription.map(plans =>
          plans.subscription_plans.filter(plan => plan.id === subscription.subscription_plan_id)
        ) || [];
      const renewSubscription = renewSubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];
      selectedPlan(renewSubscription[0][0], ACCOUNT_DETAILS_URL);

      navigateTo(`/payment-checkout`);
    }
  };

  if (subscriptions.length === 0) {
    return (
      <div styleName="sub-wrraper">
        <h4 styleName="plan-name no-plan">You do not have any plan</h4>
      </div>
    );
  }
  return subscriptions.map(subscription => {
    const defaultImg = get(config, ["publisher", "publisher", "defaultSubImg"], "");
    const isCancelled = isSubscriptionCanceled || subscription.cancelled;
    const description = (subscription.group_description && subscription.group_description.split("\n")) || [];
    let imgUrl = description.length > 1 ? description[0] : defaultImg;
    let summary = description && description.length === 1 ? description[0] : description[1];

    if (subscription.subscription_type === "campaign") {
      try {
        const res = JSON.parse(subscription.group_description);
        imgUrl = res.imageUrl;
        summary = res.summary;
      } catch (e) {
        console.log("campign description is not a valid JSON ", subscription);
        console.error(e);
      }
    }

    const checksubscriptions =
      groupSubscription.map(plans =>
        plans.subscription_plans.filter(plan => plan.id === subscription.subscription_plan_id)
      ) || [];
    const checksubscription = checksubscriptions.filter(sub => sub.length > 0 && sub[0]) || [];
    return (
      <div key={subscription.id}>
        <div styleName="sub-wrraper">
          <div styleName="img-wrapper">
            <figure>
              <img styleName="image" src={imgUrl} alt={subscription.name} />
            </figure>
          </div>

          <div styleName="info">
            <h4 styleName="plan-name">{subscription.plan_name}</h4>
            {subscription.subscription_type !== "campaign" && (
              <span styleName="expiry-date">
                {" "}
                {subscription["plan_occurrence"] === "Recurring" ? "Next due " : "Valid till "}
                {new Date(subscription.end_timestamp).toLocaleDateString("default", {
                  day: "numeric",
                  month: "short",
                  year: "numeric"
                })}
              </span>
            )}
            {subscription.subscription_type === "campaign" && <p>{summary}</p>}
          </div>
          <div styleName="modify-wraaper">
            {(subscription.plan_occurrence === "One Time" && subscription.status === "pending") ||
            subscription.subscription_type === "campaign"
              ? null
              : checksubscription.length > 0 && (
                  <button
                    styleName="button modify"
                    onClick={() =>
                      subscription.plan_occurrence === "Recurring" &&
                      (subscription.active || subscription.status === "pending") &&
                      !isCancelled
                        ? CancelSubscriptionPlan(subscription)
                        : // : paymentCheckout(subscription)
                          navigateTo("/subscription")
                    }
                  >
                    {isLoading && cancelSubscriptionState.id === subscription.id ? (
                      <Loader color="#ec2227" />
                    ) : subscription.expired || (isCancelled && subscription.plan_occurrence === "Recurring") ? (
                      "Renew"
                    ) : subscription.plan_occurrence === "Recurring" ? (
                      "Cancel"
                    ) : (
                      "Extend"
                    )}
                  </button>
                )}
            {checksubscription.length < 1 &&
            subscription.plan_occurrence === "Recurring" &&
            (subscription.active || subscription.status === "pending") &&
            !isCancelled ? (
              <button
                styleName="button modify"
                onClick={() =>
                  subscription.plan_occurrence === "Recurring" &&
                  (subscription.active || subscription.status === "pending") &&
                  !isCancelled
                    ? CancelSubscriptionPlan(subscription)
                    : paymentCheckout(subscription)
                }
              >
                Cancel
              </button>
            ) : null}
          </div>
        </div>
        {sucMessage && cancelSubscriptionState.id === subscription.id && <p styleName="success-msg">{sucMessage}</p>}
        {errorMessage && cancelSubscriptionState.id === subscription.id && <p styleName="error">{errorMessage}</p>}
      </div>
    );
  });
};

const AccountDetailsLayout = ({
  initAccessType,
  getSubscriptionForUser,
  member = {},
  config,
  navigateTo,
  cancelSubscription,
  subscriptionManage,
  isSubscriptionCanceled,
  selectedPlan,
  groupSubscription,
  campaignSubscriptions,
  hostUrl,
  paymentCheckout
}) => {
  if (!member) {
    return <LoginButton />;
  }
  const useSub = useUserSubscription();
  const [activeButton, setActiveButton] = useState("tab1");
  const [hasSubscription, setSubscription] = useState(false);
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    country: "",
    pin_code: ""
  });
  const [activeSubscription, setActiveSubscription] = useState([]);
  const [pastSubscription, setpastSubscription] = useState([]);
  const [sucMessage, setsucMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [latestExDate, setLatestExDate] = useState("");
  paymentCheckout();
  useEffect(() => {
    const subscriptonDetails = () =>
      getSubscriptionForUser()
        .then(({ subscriptions = [] }) => {
          setSubscription(true);
          setIsLoading(false);
          subscriptionManage({ status: false });
          const activeSub = subscriptions.filter(subscription => subscription.active === true);
          setActiveSubscription(activeSub);
          const pastSub = subscriptions.filter(subscription => subscription.active !== true);
          const getLatestExDate = new Date(
            Math.max.apply(
              null,
              subscriptions.map(function(e) {
                return new Date(e.end_timestamp);
              })
            )
          ).toLocaleDateString("default", {
            day: "numeric",
            month: "short",
            year: "numeric"
          });
          setLatestExDate(getLatestExDate);
          setpastSubscription(pastSub);
          return subscriptions;
        })
        .catch(error => {
          console.log("error while fetching subscription", error);
          setIsLoading(false);
          return error;
        });
    initAccessType(subscriptonDetails);
  }, []);

  useEffect(() => {
    member &&
      checkForMemberInFirebase(member)
        .then(data => {
          setUser({
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            mobile: data.phoneNumber,
            address_1: data.address_1,
            address_2: data.address_2,
            city: data.city,
            state: data.state,
            country: data.country,
            pin_code: data.pin_code
          });
        })
        .catch(error => console.log("error", error));
  }, [member]);

  function manageTab(tab) {
    setActiveButton(tab);
  }
  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUser(userObj);
  };
  function resetDetails() {
    setUser({
      first_name: "",
      last_name: "",
      email: user.email,
      mobile: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      country: "",
      pin_code: ""
    });
  }
  function updateDetails() {
    if (!user.first_name) {
      setErrorMessage("First name required");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return null;
    }
    const userObj = {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phoneNumber: user.mobile,
      address_1: user.address_1,
      address_2: user.address_2,
      city: user.city,
      state: user.state,
      country: user.country,
      pin_code: user.pin_code,
      id: member.id
    };
    updateFirebaseUser(userObj)
      .then(() => {
        setsucMessage("Information successfully updated");
        setTimeout(() => {
          setsucMessage("");
        }, 3000);
      })
      .catch(error => {
        setErrorMessage("Oops! Something went wrong");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        console.log(error);
      });
  }
  return (
    <div styleName="account-wrapper">
      <div styleName="heading-wrapper">
        <h1 styleName="account-heading">Account Information</h1>
        <hr styleName="heading-border" />
      </div>
      <div styleName="tabs">
        <button
          styleName={`${activeButton === "tab1" ? "active-button" : ""} button `}
          onClick={() => manageTab("tab1")}
        >
          Account Info{" "}
        </button>
        <button
          styleName={`${activeButton === "tab2" ? "active-button" : ""} button `}
          onClick={() => manageTab("tab2")}
        >
          All Purchases{" "}
        </button>
        {/* <button
          styleName={`${activeButton === "tab3" ? "active-button" : ""} button `}
          onClick={() => console.log("external link here")}
        >
          Merchandise{" "}
        </button> */}
        <button
          styleName={`${activeButton === "tab3" ? "active-button" : ""} button `}
          onClick={() => {
            console.log(useSub);
            if (useSub.userHasSubscription) {
              if (useSub.userSubscription[0].group_name === "Game Changer") {
                manageTab("tab3");
              }
            } else {
              window.alert(
                "Oops! This is a feature for Gamechanger subscribers only. Upgrade to Gamechanger subscription or access the podcast from our podcast player."
              );
            }
          }}
        >
          🔒 Podcast RSS 🔗{" "}
        </button>
      </div>
      <div className="subscription-details">
        {!isLoading ? (
          <React.Fragment>
            {hasSubscription && activeButton === "tab1" && (
              <div>
                <h2 styleName="heading" className="desktop-only">
                  {" "}
                  Active Subscriptions{" "}
                </h2>
                {/* {latestExDate !== "Invalid Date" && <div>Your subscription expires on: <span styleName="text-red"> {latestExDate} </span></div>} */}
                <GetCards
                  config={config}
                  subscriptions={activeSubscription}
                  navigateTo={navigateTo}
                  cancelSubscription={cancelSubscription}
                  subscriptionManage={subscriptionManage}
                  isSubscriptionCanceled={isSubscriptionCanceled}
                  selectedPlan={selectedPlan}
                  groupSubscription={groupSubscription}
                  campaignSubscriptions={campaignSubscriptions}
                />
              </div>
            )}
            {hasSubscription && activeButton === "tab2" && (
              <GetCards
                config={config}
                subscriptions={pastSubscription}
                navigateTo={navigateTo}
                cancelSubscription={cancelSubscription}
                subscriptionManage={subscriptionManage}
                isSubscriptionCanceled={isSubscriptionCanceled}
                selectedPlan={selectedPlan}
                groupSubscription={groupSubscription}
                campaignSubscriptions={campaignSubscriptions}
                hostUrl={hostUrl}
              />
            )}
            {!hasSubscription && <GetCards config={config} subscriptions={[]} />}
          </React.Fragment>
        ) : (
          <div styleName="sub-wrraper empty-card">
            <Loader color="#ec2227" />
          </div>
        )}
      </div>
      {activeButton === "tab1" && (
        <div styleName="profile-details">
          <h2 styleName="heading">Edit Profile</h2>
          <div styleName="profile-wrapper">
            <TextField
              type="text"
              value={user.first_name}
              placeholder="First Name"
              id="first_name"
              onChange={setData}
            />
            <TextField type="text" value={user.last_name} placeholder="Last Name" id="last_name" onChange={setData} />
            <TextField type="email" value={user.email} placeholder="Email Address" id="email" disabled />
            <TextField
              type="tel"
              value={user.mobile}
              pattern="^\d{10}$"
              placeholder="Phone Number"
              id="mobile"
              onChange={setData}
            />
            <h3 styleName="heading address">Address</h3>
            <TextField
              type="text"
              value={user.address_1}
              placeholder="Address Line 1"
              id="address_1"
              onChange={setData}
            />
            <TextField
              type="text"
              value={user.address_2}
              placeholder="Address Line 2"
              id="address_2"
              onChange={setData}
            />
            <TextField type="text" value={user.city} placeholder="City" id="city" onChange={setData} />
            <TextField type="text" value={user.state} placeholder="State" id="state" onChange={setData} />
            <TextField type="text" value={user.country} placeholder="Country" id="country" onChange={setData} />
            <TextField
              type="text"
              value={user.pin_code}
              pattern="[0-9]"
              maxlength="6"
              placeholder="PIN Code"
              id="pin_code"
              onChange={setData}
            />
          </div>
          {sucMessage && <p styleName="success-msg">{sucMessage}</p>}
          {errorMessage && <p styleName="error">{errorMessage}</p>}
          <div styleName="actions">
            <button styleName="button reset" onClick={() => resetDetails()}>
              RESET
            </button>
            <button styleName="button updated" onClick={() => updateDetails()}>
              UPDATE
            </button>
          </div>
        </div>
      )}
      {activeButton === "tab3" && <PodcastRssComponent />}
      {activeButton !== "tab3" && (
        <div styleName="button-wrapper">
          <div styleName="first-btn">
            <a styleName="btn-style" className="nl-btn nl-btn-large" href={`${hostUrl}/subscription-explained`}>
              Subscription Explained
            </a>
          </div>
          <div styleName="first-btn">
            <a styleName="btn-style" className="nl-btn nl-btn-large" href={`${hostUrl}/faq`}>
              Frequently Asked Questions
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

AccountDetailsLayout.propTypes = {
  member: PropTypes.object,
  initAccessType: PropTypes.func,
  getSubscriptionForUser: PropTypes.func,
  config: PropTypes.object,
  navigateTo: PropTypes.func,
  cancelSubscription: PropTypes.func,
  subscriptionManage: PropTypes.func,
  isSubscriptionCanceled: PropTypes.bool,
  selectedPlan: PropTypes.func,
  groupSubscription: PropTypes.array,
  campaignSubscriptions: PropTypes.array
};

const AccountDetailsBase = ({
  member = {},
  config = {},
  navigateTo,
  subscriptionManage,
  isSubscriptionCanceled,
  selectedPlan,
  subscriptions,
  campaignSubscriptions,
  hostUrl,
  paymentCheckout
}) => {
  const integrationsConfig = IntegrationData();
  const email = get(member, ["email"], "");
  const phone = get(member, ["phone-number"], "");
  const isStaging = get(config, ["publisher", "publisher", "accessTypeEnvironment"], true);
  const accessTypeKey = isStaging ? integrationsConfig.stagingAccessTypeKey : integrationsConfig.accessTypeKey;
  const enableAccesstype = get(config, ["publisher", "publisher", "enableAccesstype"], true);
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;
  return (
    <AccessType
      enableAccesstype={enableAccesstype}
      isStaging={isStaging}
      accessTypeKey={accessTypeKey}
      email={email}
      phone={phone}
      isAccessTypeCampaignEnabled={true}
      accessTypeBkIntegrationId={accessTypeBkIntegrationId}
    >
      {({ initAccessType, getSubscriptionForUser, cancelSubscription }) => {
        return (
          <AccountDetailsLayout
            initAccessType={initAccessType}
            getSubscriptionForUser={getSubscriptionForUser}
            member={member}
            config={config}
            navigateTo={navigateTo}
            cancelSubscription={cancelSubscription}
            subscriptionManage={subscriptionManage}
            isSubscriptionCanceled={isSubscriptionCanceled}
            selectedPlan={selectedPlan}
            groupSubscription={subscriptions}
            campaignSubscriptions={campaignSubscriptions}
            hostUrl={hostUrl}
            paymentCheckout={paymentCheckout}
          />
        );
      }}
    </AccessType>
  );
};

AccountDetailsBase.propTypes = {
  member: PropTypes.object,
  config: PropTypes.object,
  navigateTo: PropTypes.func,
  subscriptionManage: PropTypes.func,
  isSubscriptionCanceled: PropTypes.bool,
  selectedPlan: PropTypes.func,
  subscriptions: PropTypes.array,
  campaignSubscriptions: PropTypes.array
};

const mapStateToProps = state => {
  return {
    config: get(state, ["qt", "config"], {}),
    member: get(state, ["member"], null),
    isSubscriptionCanceled: get(state, ["isSubscriptionCancel", "status"], false),
    subscriptions: get(state, ["subscriptions"], []),
    campaignSubscriptions: get(state, ["accessTypeCampaignSubscriptions"], []),
    hostUrl: get(state, ["qt", "currentHostUrl"], "https://www.newslaundry.com")
  };
};

const mapDispatchToProps = dispatch => ({
  navigateTo: url => global.app.navigateToPage(dispatch, url),
  subscriptionManage: function(payload) {
    dispatch({
      type: IS_SUBSCRIPTION_CANCEL,
      payload: payload
    });
  },
  selectedPlan: function(plan, redirectUrl) {
    dispatch({
      type: SELECTED_PLAN,
      plan: plan,
      planType: "standard",
      redirectUrl: redirectUrl
    });
  },
  paymentCheckout: function() {
    dispatch({
      type: PAYMENT_CHECKOUT_PAGE,
      payload: "subscription"
    });
  }
});

function PodcastRssComponent() {
  const useSub = useUserSubscription();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (useSub.loading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [useSub.loading]);

  return (
    <div styleName="wrapper">
      <h2>Private RSS link for our podcasts that are behind the paywall</h2>
      <br />
      <p>
        As much as we prefer to have subscribers use our podcast player on the website, we want to make the podcast
        experience as frictionless as possible. So while we work on our iOS and Android apps, we have made private RSS
        links via which Gamechanger subscribers can access our paywall podcasts on their favorite podcast apps.{" "}
      </p>
      <p>Apps that will work with our private RSS link:</p>
      <div style={{ margin: "0.5rem auto" }}>
        iOS : <IosAppLogos />
      </div>
      <div style={{ margin: "0.5rem auto" }}>
        Android : <AndroidAppLogos />
      </div>

      <div styleName="card-container">
        {loading ? <Loader color={"#ec2227"} width={"80px"} /> : shows.map(show => <Card key={show._id} show={show} />)}
      </div>
      <div styleName="instructions">
        <h3>How do I add the RSS link to my podcast player?</h3>
        <h4>Apple Podcast</h4>
        <p>
          Click on Get Feed Link below the show icon > Launch Apple Podcasts on your phone > Tap on Library from the
          menu items at the bottom > Click on Edit at the top right > Choose Add a Show by URL > Paste the copied link
          and hit Subscribe
        </p>{" "}
        <h4>Google Podcast</h4>
        <p>
          Click on Get Feed Link below the show icon > Launch Google Podcasts on your phone >Tap on Activity from the
          menu icons at the bottom > Choose Subscriptions from the menu at the top > Click on the kebab icon (⋮) at the
          top right > Click on Add by RSS feed > Paste the copied link and hit Subscribe
        </p>{" "}
        <h4>Pocket Casts</h4>
        <p>
          Click on Get Feed Link below the show icon > Launch Pocket Casts on your phone > Tap on Discover > Paste the
          copied link and tap on the search icon > Select the show and hit Subscribe
        </p>{" "}
        <h4>Podcast Addict</h4>{" "}
        <p>
          Click on Get Feed Link below the show icon > Launch Podcast Addict app on your phone > Tap the “+” icon in the
          top right > Click on the RSS feed icon > Paste the copied link and hit Add{" "}
        </p>
        <h4>Castro</h4>{" "}
        <p>
          Click on Get Feed Link below the show icon > Launch Castro on your phone > Tap on search icon / Discover on
          the menu icons at the bottom > Paste the copied link > Select the show and hit Subscribe
        </p>
      </div>
    </div>
  );
}

function IosAppLogos() {
  const links = [
    "https://www.contiki.com/v-ch19bla5r41a/-/media/cml/resources/out-of-office-podcast/contiki-out-of-office-podcast-subscribe-apple-badge.png",
    "https://lh3.googleusercontent.com/VwSc0fESmGvRQ-6cv7-_sONmRRo1aiXJsfsf0NJzhN58i9mlOVf1W83aUjVVtiJNSZY=w268",
    "https://www.pocketcasts.com/assets/images/badges/pocketcasts_large_light.svg",
    "http://supertop.co/castro/assets/listen-in-castro.svg"
  ];
  return (
    <div style={{ display: "inline-flex", gap: "20px", margin: "auto 2rem", flexFlow: "row wrap" }}>
      {links.map(l => (
        <img alt={l} height="48px" key={l} src={l} />
      ))}
    </div>
  );
}

function AndroidAppLogos() {
  const links = [
    "https://lh3.googleusercontent.com/VwSc0fESmGvRQ-6cv7-_sONmRRo1aiXJsfsf0NJzhN58i9mlOVf1W83aUjVVtiJNSZY=w268",
    "https://www.pocketcasts.com/assets/images/badges/pocketcasts_large_light.svg",
    "https://play-lh.googleusercontent.com/m6FeLOkUfP8qTZNXKFSSI8_exI-SlGJRcIArl3gRm3-VninL7l1RdYlPkkf2CfbBnA=s180-rw",
    "https://play-lh.googleusercontent.com/VMgWF3Uv2rTu3Z7fHFs7qhsAsfru7_q7IRN7tpT-bRyqkosxlg5RiQm7hmcfT2iAo_Y=s180-rw"
  ];
  return (
    <div style={{ display: "inline-flex", gap: "20px", margin: "auto 2rem", flexFlow: "row wrap" }}>
      {links.map(l => (
        <img alt={l} height="48px" key={l} src={l} />
      ))}
    </div>
  );
}

function Card({ show }) {
  const useSub = useUserSubscription();
  const [isCopied, handleCopy] = useCopyToClipboard();
  const [tokenState, setTokenState] = useState("");
  const [linkButton, setLinkButton] = useState(true);
  const [buttonText, setButtonText] = useState("Get Feed Link");
  const showClickHandler = showId => async e => {
    if (!isEmpty(useSub)) {
      if (useSub.userHasSubscription && useSub.userSubscription[0].group_name === "Game Changer") {
        setButtonText(Loader);
        const { token } = await getPodcastToken(
          useSub.userSubscription[0].subscriber_id,
          useSub.userSubscription[0].group_name,
          useSub.userSubscription[0].end_timestamp,
          showId
        );
        setTokenState(`https://newslaundry.com/podcast-rss/getFeed/${token}`);
        setLinkButton(false);
      } else {
        window.alert("No subscription or Not Subscribed as Game Changer");
      }
    } else {
      window.alert("login!");
    }
  };

  useEffect(() => {
    if (isCopied) {
      window.alert("The Rss Feed link has been Copied, paste it into your Podcast Client");
    }
  }, [isCopied]);

  return (
    <div key={show._id} styleName="card">
      <img src={show.cover} height="300px" />
      {linkButton ? (
        <button onClick={showClickHandler(show._id)}>{buttonText}</button>
      ) : (
        <div styleName="contentcopy">
          <input defaultValue={tokenState} type="text" readOnly />
          <button onClick={() => handleCopy(tokenState)}>
            <MdContentCopy color="white" size="22px" />
          </button>
        </div>
      )}
    </div>
  );
}
export const AccountDetails = connect(mapStateToProps, mapDispatchToProps)(AccountDetailsBase);
